module.exports = {
	"dk": {
		"mainMenuLinks": [
			{
				"url": "/sport/fodbold",
				"name": "Fodbold",
				"sublinks": [
					{
						"url": "/sport/fodbold/nyheder",
						"name": "Nyheder"
					},
					{
						"url": "/sport/fodbold/hold",
						"name": "Hold"
					},
					{
						"url": "/sport/fodbold/liga",
						"name": "Liga"
					}
				]
			},
			{
				"url": "/sport/motorsport",
				"name": "Motorsport",
				"sublinks": [
					{
						"url": "/sport/motorsport/nyheder",
						"name": "Nyheder"
					},
					{
						"url": "/sport/motorsport/liga/formula-1",
						"name": "Formel 1"
					},
					{
						"url": "/sport/motorsport/liga/formula-2",
						"name": "Formel 2"
					},
					{
						"url": "/sport/motorsport/liga/formula-3",
						"name": "Formel 3"
					},
					{
						"url": "/sport/motorsport/liga/imsa",
						"name": "IMSA"
					}
				]
			},
			{
				"url": "/sport/kampsport",
				"name": "Boksning/UFC",
				"sublinks": [
					{
						"url": "/sport/kampsport/nyheder",
						"name": "Nyheder"
					}
				]
			},
			{
				"url": "/sport/golf",
				"name": "Golf",
				"sublinks": [
					{
						"url": "/sport/golf/nyheder",
						"name": "Nyheder"
					}
				]
			},
			{
				"url": "/sport/handbold",
				"name": "Håndbold",
				"sublinks": [
					{
						"url": "/sport/handbold/nyheder",
						"name": "Nyheder"
					}
				]
			},
			{
				"url": "/sport/darts",
				"name": "Dart",
				"sublinks": [
					{
						"url": "/sport/darts/nyheder",
						"name": "Nyheder"
					}
				]
			},
			{
				"url": "/sport/ishockey",
				"name": "Ishockey",
				"sublinks": [
					{
						"url": "/sport/ishockey/nyheder",
						"name": "Nyheder"
					},
					{
						"url": "/sport/ishockey/hold",
						"name": "Hold"
					},
					{
						"url": "/sport/ishockey/liga",
						"name": "Liga"
					}
				]
			},
			{
				"url": "/sport/andre",
				"name": "Andre",
				"sublinks": [
					{
						"url": "/sport/andre/nyheder",
						"name": "Nyheder"
					}
				]
			}
		],
		"secondaryMenuLinks": [
			{
				"url": "http://viaplay.dk/sport",
				"name": "Viaplay",
				"trackingId": "Viaplay"
			},
			{
				"url": "/tv-guide",
				"name": "TV-guide"
			}
		],
		"footer": [
			{
				"title": "Information",
				"links": [
					{
						"name": "Kontakt",
						"url": "/kontakt",
						"component": "TextPages/TextPage"
					},
					{
						"name": "Brugervilkår",
						"url": "/brugervilkar",
						"component": "TextPages/TextPage"
					},
					{
						"name": "Cookiepolitik",
						"url": "/cookies",
						"component": "TextPages/TextPageCookie"
					},
					{
						"name": "Cookiedeklarationen",
						"url": "/cookiedeklarationen",
						"component": "TextPages/TextPageCookiedeklarationen"
					},
					{
						"name": "Privatlivspolitik",
						"url": "https://www.viaplaygroup.com/about/privacy-data-protection",
						"component": "TextPages/TextPage"
					},
					{
						"name": "Ledige stillinger",
						"url": "https://careers.viaplaygroup.com/"
					}
				]
			},
			{
				"title": "Websites",
				"links": [
					{
						"name": "Instagram",
						"url": "https://www.instagram.com/tv3sportdk/"
					},
					{
						"name": "Facebook",
						"url": "https://facebook.com/tv3sport"
					},
					{
						"name": "Twitter",
						"url": "https://twitter.com/TV3sportdk"
					},
					{
						"name": "tv3sport.dk",
						"url": "http://tv3sport.dk"
					},
					{
						"name": "pluto.tv",
						"url": "https://pluto.tv/da/live-tv/pluto-tv-film-se"
					},
					{
						"name": "onside.dk",
						"url": "http://onside.dk"
					},
					{
						"name": "viaplay.dk",
						"url": "http://viaplay.dk"
					},
					{
						"name": "tv3panelet.dk",
						"url": "http://tv3panelet.dk"
					},
					{
						"name": "viaplaygroup.com",
						"url": "https://www.viaplaygroup.com/"
					}
				]
			}
		]
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/config/menus.json
// module id = 410
// module chunks = 6